const resumeData = {
    "name": "James Ma",
    "role": "PHP/Web Developer",
    "roleDescription": "Looking for Web/PHP Developer role",
    "updateDate": "02-03-2026",
    "linkedin":{
        url: "https://www.linkedin.com/in/chenganma/",
        imagePath: "#",
    },
    "github":{
        url: "https://github.com/chenganma",
        imagePath: "#",
    },
    "profolio":{
        url: "https://chenganma.com",
        imagePath: "#",
    },
    "work":[
     {
        id: 1,
        title: "PHP Programmer",
        company: "Lyman Companies",
        location: "Excelsior, MN",
        date: "August 2016 - June 2019",
        "description": [
        '• Research and analyze information and specifications for new features to streamline implementation of future software releases; consult with project managers and internal customers and effectively explain my findings',
        '• Decreasing spending by thousands of dollars a day by developing a web application for the credit return department that is accessed via tablet for streamlined data retrieval to eliminate paper usage and excess travelling of employees to locate records',
        '• Implementing photo-taking function into current web page to simplify the verification and documentation of product conditions',
        '• Boosting working efficiency by building a department scheduler for the manager to better organize drivers’ schedules and gain a clearer understanding of how to reallocate resources and maximize the productivity of working hours',
        '• Reduce user error by collaborating with the project manager and a remote coworker to test new code in development system for quality assurance and better handling of vendor’s special orders',
        '• Liaise with management and supervisors bi-annually to communicate ideas for improving working efficiency',
        '• Maintain web system with PHP and MySQL for data processing and HTML, CSS, and JavaScript for front-end layout and functions'
        ]
     },
     {
        id: 2,
        title: "Online Content Manger",
        company: "Stoutonia",
        location: "Menomonie, WI",
        date: "Sep 2015 - May 2016",
        "description": [
        '• Managed a website’s content presentation, studied traffic and viewership patterns and corresponded with the chief editor; posted 24 new articles and images monthly during high engagement hours to boost readership',
        '• Identified readers’ topical interests using the Google Analytic tool and tailored content to meet demand',
        '• Increased visitation rate of social media channels by identifying trends and partnering with a social media specialist'
        ]
     },
     {
        id: 3,
        title: "Web Developer",
        company: "IFO Corp",
        location: "Taipei, Taiwan",
        date: "Sep 2012 - Feb 2013",
        "description": [
        '• Saved company $10K by building an e-commerce website from scratch using OpenCart to expand online marketing and reach more customers without hiring an outside web development company',
        '• Configured front-end (HTML, CSS) and back-end (MySQL) within two weeks; activated several payment options for customers',
        '• Managed the content, website layouts (HTML, CSS), and product advertisings of official website',
        '• Refined database for the annual "Smart Phone Stand" competition official website using MySQL to increase usability',
        '• Utilized Adobe Photoshop and Illustrator to redesign product package boxes, instruction labels and numerous bar codes'
        ]
     }
    ],
    "projects":[
     {
        id: 1,
        name: "Maxwell Construction",
        location: "Chicago, Illinois ",
        date: "July 2016 - August 2016",
        "description": [
        '• Generated new business by building a mobile/tablet website to advertise my clients’ expertise and work performance',
        '• Configured front-end with HTML and CSS and implemented Bootstrap to layout the landing page; optimized SEO using metatag descriptions and alt name tags for images',
        ]
     },
     {
        id: 2,
        name: "Theos Medical System",
        location: "Santa Clara, California",
        date: "August 2016 - Sep 2015",
        "description": [
        '• Arranged page layouts and maintained several product specifications for e-Commerce site and blogs',
        '• Accelerated development processes to meet requirements (WordPress) within a month; tested payment processes, security status, and plugin functionality',
        ]
     },
    ],
    "skills" :['PHP', 'MySQL', 'HTML', 'CSS', 'AWS', 'Vue.js', 'React.js', 'OpenCart', 'WordPress', 'Bootstrap', 'PhotoShop', 'Illustrate', 'GitHub', 'Mac OS', 'Windows']
}


export default resumeData